import { render } from "./TarificateurSante.vue?vue&type=template&id=6bd07794&scoped=true"
import script from "./TarificateurSante.vue?vue&type=script&lang=js"
export * from "./TarificateurSante.vue?vue&type=script&lang=js"

import "./TarificateurSante.vue?vue&type=style&index=0&id=6bd07794&scoped=true&lang=css"

import exportComponent from "/builds/fr.swissLife.nxtCms/cms/nxtcms/nxt-front-ui/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd07794"]])

export default __exports__